import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { type SignedUrl } from "@/lib/backend/api";
import { type SignedKeyQueryOptions } from "@/lib/requests/file/file.get-signed-key";
import { cn } from "@/lib/style/cva.config";

type QueryOptions = ReturnType<SignedKeyQueryOptions>;

interface QueryImageProps extends Omit<QueryOptions, "queryKey" | "queryFn"> {
  width: number;
  height: number;
  alt: string;
  className?: string;
  fallbackSrc?: string;
}

export function SignedQueryImage({
  width,
  height,
  className = "",
  alt,
  fallbackSrc,
  ...queryOptions
}: QueryImageProps) {
  const { data: src, isLoading } = useQuery(queryOptions as UseQueryOptions<SignedUrl, Error>);

  const placeholderSrc = fallbackSrc || `https://placehold.co/${width}/${height}/png`;

  return (
    <div className={cn("", className)}>
      {!isLoading && !src && (
        <img src={placeholderSrc} width={width} height={height} alt="Loading placeholder" />
      )}
      {!isLoading && src && (
        <img
          src={src.url}
          width={width}
          height={height}
          className={cn("transition-opacity duration-300", {
            "opacity-0": isLoading,
          })}
          alt={alt}
        />
      )}
    </div>
  );
}
